var map = {
	"./cart/en.json": 75505,
	"./cart/jp.json": 37982,
	"./cart/zh-CN.json": 1945,
	"./confirm-order/en.json": 96610,
	"./confirm-order/jp.json": 15248,
	"./confirm-order/zh-CN.json": 39464,
	"./create-application/en.json": 99385,
	"./create-application/jp.json": 91610,
	"./create-application/zh-CN.json": 46034,
	"./create-require-list/en.json": 83119,
	"./create-require-list/jp.json": 9789,
	"./create-require-list/zh-CN.json": 25655,
	"./create-requisition/en.json": 34433,
	"./create-requisition/jp.json": 35297,
	"./create-requisition/zh-CN.json": 94953,
	"./demand/demand-portal/en.json": 92259,
	"./demand/demand-portal/jp.json": 4658,
	"./demand/demand-portal/zh-CN.json": 52445,
	"./demand/demand-submission/en.json": 59183,
	"./demand/demand-submission/jp.json": 50021,
	"./demand/demand-submission/zh-CN.json": 47053,
	"./evaluate-detail/en.json": 98738,
	"./evaluate-detail/jp.json": 17345,
	"./evaluate-detail/zh-CN.json": 59655,
	"./evaluate-edit/en.json": 65893,
	"./evaluate-edit/jp.json": 4552,
	"./evaluate-edit/zh-CN.json": 94322,
	"./evaluate/en.json": 29406,
	"./evaluate/jp.json": 33617,
	"./evaluate/zh-CN.json": 79202,
	"./favorite/en.json": 43316,
	"./favorite/jp.json": 27636,
	"./favorite/zh-CN.json": 27125,
	"./frequent/en.json": 65741,
	"./frequent/jp.json": 74908,
	"./frequent/zh-CN.json": 61057,
	"./info/en.json": 23490,
	"./info/jp.json": 69257,
	"./info/zh-CN.json": 29063,
	"./list/en.json": 56599,
	"./list/jp.json": 26259,
	"./list/zh-CN.json": 89903,
	"./login/en.json": 56093,
	"./login/jp.json": 9215,
	"./login/zh-CN.json": 85,
	"./main/en.json": 88998,
	"./main/jp.json": 92858,
	"./main/zh-CN.json": 52800,
	"./my-order/en.json": 19462,
	"./my-order/jp.json": 72566,
	"./my-order/zh-CN.json": 30827,
	"./notice/en.json": 22523,
	"./notice/jp.json": 45155,
	"./notice/zh-CN.json": 87517,
	"./order-details/en.json": 60873,
	"./order-details/jp.json": 13312,
	"./order-details/zh-CN.json": 84897,
	"./order-logistics-detail/en.json": 23394,
	"./order-logistics-detail/jp.json": 94271,
	"./order-logistics-detail/zh-CN.json": 91415,
	"./order-receive-confirm-order/en.json": 9815,
	"./order-receive-confirm-order/jp.json": 41758,
	"./order-receive-confirm-order/zh-CN.json": 53817,
	"./order-return-order-create/en.json": 16329,
	"./order-return-order-create/jp.json": 78557,
	"./order-return-order-create/zh-CN.json": 17781,
	"./order-return-order-detail/en.json": 46351,
	"./order-return-order-detail/jp.json": 1163,
	"./order-return-order-detail/zh-CN.json": 71843,
	"./portal/en.json": 4770,
	"./portal/jp.json": 37124,
	"./portal/zh-CN.json": 82389,
	"./pr-new-import/en.json": 5528,
	"./pr-new-import/jp.json": 93034,
	"./pr-new-import/zh-CN.json": 34449,
	"./pr-paas/create/easy-edit-loading/en.json": 9189,
	"./pr-paas/create/easy-edit-loading/jp.json": 20819,
	"./pr-paas/create/easy-edit-loading/zh-CN.json": 7761,
	"./pr-paas/create/edit/en.json": 64727,
	"./pr-paas/create/edit/jp.json": 50647,
	"./pr-paas/create/edit/zh-CN.json": 93956,
	"./pr-paas/create/info/en.json": 9668,
	"./pr-paas/create/info/jp.json": 10341,
	"./pr-paas/create/info/zh-CN.json": 95285,
	"./pr-paas/new-import-create/edit/en.json": 28483,
	"./pr-paas/new-import-create/edit/jp.json": 45636,
	"./pr-paas/new-import-create/edit/zh-CN.json": 8651,
	"./pr-paas/new-import-create/info/en.json": 6130,
	"./pr-paas/new-import-create/info/jp.json": 2714,
	"./pr-paas/new-import-create/info/zh-CN.json": 89358,
	"./pr-paas/pr-center/en.json": 65988,
	"./pr-paas/pr-center/jp.json": 62316,
	"./pr-paas/pr-center/zh-CN.json": 40110,
	"./product-compare/en.json": 56511,
	"./product-compare/jp.json": 14337,
	"./product-compare/zh-CN.json": 99572,
	"./receive-order-detail/en.json": 55258,
	"./receive-order-detail/jp.json": 63255,
	"./receive-order-detail/zh-CN.json": 20510,
	"./receive-order/en.json": 41123,
	"./receive-order/jp.json": 98996,
	"./receive-order/zh-CN.json": 37360,
	"./req/en.json": 59343,
	"./req/jp.json": 79095,
	"./req/zh-CN.json": 16070,
	"./require-list-detail/en.json": 10643,
	"./require-list-detail/jp.json": 74780,
	"./require-list-detail/zh-CN.json": 19679,
	"./require-list/en.json": 33317,
	"./require-list/jp.json": 9825,
	"./require-list/zh-CN.json": 27554,
	"./requisition/detail/en.json": 84113,
	"./requisition/detail/jp.json": 69122,
	"./requisition/detail/zh-CN.json": 89684,
	"./requisition/edit/en.json": 85848,
	"./requisition/edit/jp.json": 48231,
	"./requisition/edit/zh-CN.json": 17612,
	"./requisition/list/en.json": 29871,
	"./requisition/list/jp.json": 3879,
	"./requisition/list/zh-CN.json": 87014,
	"./requisition/requisitionDetail(del)/en.json": 78701,
	"./requisition/requisitionDetail(del)/jp.json": 20590,
	"./requisition/requisitionDetail(del)/zh-CN.json": 70944,
	"./reset/en.json": 62448,
	"./reset/jp.json": 88310,
	"./reset/zh-CN.json": 43235,
	"./return-order/en.json": 28911,
	"./return-order/jp.json": 65277,
	"./return-order/zh-CN.json": 11544,
	"./scene-list/en.json": 6430,
	"./scene-list/jp.json": 22220,
	"./scene-list/zh-CN.json": 79924,
	"./setting/address/en.json": 72770,
	"./setting/address/jp.json": 72853,
	"./setting/address/zh-CN.json": 68792,
	"./setting/password/en.json": 75672,
	"./setting/password/jp.json": 80457,
	"./setting/password/zh-CN.json": 13125,
	"./setting/personal/en.json": 75579,
	"./setting/personal/jp.json": 82171,
	"./setting/personal/zh-CN.json": 48216,
	"./store/en.json": 33729,
	"./store/jp.json": 93444,
	"./store/zh-CN.json": 16080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24838;